import React from 'react';
import StatisticsCardsRepair from '../components/stats/StatisticsCardsRepair';
import Repairs from '../components/layout/repairs/Repairs';

const Overview = () => {
  return (
    <>
      <StatisticsCardsRepair />
      <Repairs />
    </>
  );
};

export default Overview;
